"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[665],{

/***/ 665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ viral; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(9496);
// EXTERNAL MODULE: ./src/layouts/index.ts + 2 modules
var layouts = __webpack_require__(2039);
// EXTERNAL MODULE: ./src/layouts/pages/business/index.ts + 5 modules
var business = __webpack_require__(6291);
// EXTERNAL MODULE: ./src/utils/index.ts + 10 modules
var utils = __webpack_require__(7925);
;// CONCATENATED MODULE: ./src/views/business/viral/sections/about.tsx




var AboutSection = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(business/* AboutSectionLayout */.qv, {
        name: (0,utils.t)("pages.business.viral.sections.about.name"),
        title: (0,utils.t)("pages.business.viral.sections.about.title"),
        card1Props: {
            contents: {
                key: (0,utils.t)("pages.business.viral.sections.contents.title1"),
                title: (0,utils.t)("pages.business.viral.sections.contents.title1"),
                body: (0,utils.t)("pages.business.viral.sections.contents.body1")
            },
            imgSrc: "/pages/business/viral/sections/about/bg_1.webp"
        },
        card2Props: {
            contents: {
                key: (0,utils.t)("pages.business.viral.sections.contents.title2"),
                title: (0,utils.t)("pages.business.viral.sections.contents.title2"),
                body: [
                    (0,utils.t)("pages.business.viral.sections.contents.body2-1"),
                    (0,utils.t)("pages.business.viral.sections.contents.body2-2"), 
                ]
            },
            imgSrc: "/pages/business/viral/sections/about/bg_2.webp"
        }
    });
};
/* harmony default export */ var about = (AboutSection);

// EXTERNAL MODULE: ./src/views/business/index.ts + 3 modules
var views_business = __webpack_require__(7812);
;// CONCATENATED MODULE: ./src/views/business/viral/sections/process.tsx




var ProcessSection = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(business/* ProcessSectionLayout */.Qc, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(views_business/* ProcessFeature */.z3, {
                index: "01",
                title: "요청",
                description: "3DAY",
                iconUrl: "/pages/business/viral/sections/process/icon_1.png",
                contents: [
                    "수량/제공내역확정",
                    "체험단 섭외",
                    "섭외 인원 선별",
                    "블랙리스트 체크"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(views_business/* ProcessFeature */.z3, {
                index: "02",
                title: "기획",
                description: "2DAY",
                iconUrl: "/pages/business/viral/sections/process/icon_2.png",
                contents: [
                    "진행인원 확정",
                    "가이드 제작",
                    "이벤트 제작(별도)",
                    "기타 진행준비"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(views_business/* ProcessFeature */.z3, {
                index: "03",
                title: "진행",
                description: "7DAY",
                iconUrl: "/pages/business/viral/sections/process/icon_3.png",
                contents: [
                    "체험단 체험 진행",
                    "가이드 배포",
                    "진행 현황 관리",
                    "원고 컨펌",
                    "데일리 게재 보고", 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(views_business/* ProcessFeature */.z3, {
                index: "04",
                title: "완료",
                description: "1~2DAY",
                iconUrl: "/pages/business/viral/sections/process/icon_4.png",
                contents: [
                    "노출 현황 체크",
                    "최종 게재 보고"
                ]
            })
        ]
    });
};
/* harmony default export */ var process = (ProcessSection);

;// CONCATENATED MODULE: ./src/views/business/viral/sections/specialty.tsx




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var specialtyFeatureProps = {
    textWrapProps: {
        w: {
            base: "80%",
            md: "95%"
        }
    }
};
var SpecialtySection = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(business/* SpecialtySectionLayout */.Ts, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(views_business/* SpecialtyFeature */.Eu, _objectSpread({
                title: "SPECIALTY",
                description: "커뮤니티에 실제 활동하는 유저를 섭외하여 진행하며 상황에 따라 육성 아이디로 진행이 가능합니다.",
                iconUrl: "/pages/business/viral/sections/specialty/icon_1.png"
            }, specialtyFeatureProps)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(views_business/* SpecialtyFeature */.Eu, _objectSpread({
                title: "DETAIL",
                description: "높은 캠페인 이해도를 바탕으로 디테일한 원고 작성을 통해 낮은 삭제율, 높은 KPI가 확보됩니다",
                iconUrl: "/pages/business/viral/sections/specialty/icon_2.png"
            }, specialtyFeatureProps)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(views_business/* SpecialtyFeature */.Eu, _objectSpread({
                title: "ACTIVITY",
                description: "이벤트, 핫딜(제품판매), 브랜드 등 다양한 콘텐츠 영역에 걸쳐 진행가능합니다.",
                iconUrl: "/pages/business/viral/sections/specialty/icon_3.png"
            }, specialtyFeatureProps))
        ]
    });
};
/* harmony default export */ var specialty = (SpecialtySection);

// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+media-query@2.0.4_@chakra-ui+system@1.11.2_@chakra-ui+theme@1.14.0_react@17.0.2/node_modules/@chakra-ui/media-query/dist/chakra-ui-media-query.esm.js
var chakra_ui_media_query_esm = __webpack_require__(6798);
// EXTERNAL MODULE: ./src/layout/index.ts + 16 modules
var layout = __webpack_require__(7818);
;// CONCATENATED MODULE: ./src/views/business/viral/sections/works/works.tsx






var WorksSection = function() {
    var variant = (0,chakra_ui_media_query_esm/* useBreakpointValue */.Sx)({
        base: "rounded",
        md: "flat"
    });
    var contentNode = (0,react.useMemo)(function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(works_section_layout, {
                    title: "블로그 체험단",
                    titleProps: {
                        pb: {
                            base: "1.5rem",
                            md: "0.2rem"
                        },
                        textAlign: {
                            base: "center",
                            md: "left"
                        }
                    },
                    sectionProps: {
                        name: "worksBlog",
                        sectionSize: layout/* SectionSize.MD */.f3.MD,
                        pbMult: 0.75
                    },
                    cardProps: {
                        variant: variant,
                        contentWrapProps: {
                            pos: "relative",
                            left: {
                                md: "-1.2rem"
                            },
                            borderTopRadius: {
                                base: "2xl",
                                md: undefined
                            }
                        },
                        contents: [
                            {
                                key: (0,utils.t)("pages.business.viral.sections.works.sections.blog.title1"),
                                title: (0,utils.t)("pages.business.viral.sections.works.sections.blog.title1"),
                                body: [
                                    (0,utils.t)("pages.business.viral.sections.works.sections.blog.body1-1"),
                                    (0,utils.t)("pages.business.viral.sections.works.sections.blog.body1-2"), 
                                ]
                            },
                            {
                                key: (0,utils.t)("pages.business.viral.sections.works.sections.blog.title2"),
                                title: (0,utils.t)("pages.business.viral.sections.works.sections.blog.title2"),
                                body: [
                                    (0,utils.t)("pages.business.viral.sections.works.sections.blog.body2-1"),
                                    (0,utils.t)("pages.business.viral.sections.works.sections.blog.body2-2"),
                                    (0,utils.t)("pages.business.viral.sections.works.sections.blog.body2-3"),
                                    (0,utils.t)("pages.business.viral.sections.works.sections.blog.body2-4"), 
                                ]
                            },
                            {
                                key: (0,utils.t)("pages.business.viral.sections.works.sections.blog.title3"),
                                title: (0,utils.t)("pages.business.viral.sections.works.sections.blog.title3"),
                                body: [
                                    (0,utils.t)("pages.business.viral.sections.works.sections.blog.body3-1"),
                                    (0,utils.t)("pages.business.viral.sections.works.sections.blog.body3-2"), 
                                ]
                            }, 
                        ],
                        imgSrc: "/pages/business/viral/sections/works/bg_blog.png",
                        imgProps: {
                            maxW: "40rem",
                            pos: {
                                base: "relative",
                                md: "absolute"
                            },
                            left: {
                                'md': "40vw",
                                '2xl': "50vw"
                            },
                            bottom: {
                                md: "-10%"
                            },
                            zIndex: 2
                        },
                        reverse: true
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(works_section_layout, {
                    title: "인스타그램 체험단",
                    titleProps: {
                        p: {
                            base: "0 0 2rem 0",
                            md: "0 14rem"
                        },
                        textAlign: {
                            base: "center",
                            md: "right"
                        }
                    },
                    sectionProps: {
                        name: "worksSns",
                        sectionType: layout/* SectionType.GRAY */.bA.GRAY,
                        sectionSize: layout/* SectionSize.LG */.f3.LG,
                        pbMult: 0.75
                    },
                    cardProps: {
                        variant: variant,
                        cardWrapProps: {
                            bg: {
                                base: "bg.gray",
                                md: "bg.gray"
                            },
                            maxHeight: {
                                md: "30%"
                            }
                        },
                        contentWrapProps: {
                            bg: {
                                base: "white",
                                md: "bg.gray"
                            },
                            gap: "2rem",
                            borderTopRadius: {
                                base: "2xl",
                                md: undefined
                            }
                        },
                        contents: [
                            {
                                key: (0,utils.t)("pages.business.viral.sections.works.sections.sns.title1"),
                                title: (0,utils.t)("pages.business.viral.sections.works.sections.sns.title1"),
                                body: [
                                    (0,utils.t)("pages.business.viral.sections.works.sections.sns.body1-1"),
                                    (0,utils.t)("pages.business.viral.sections.works.sections.sns.body1-2"), 
                                ]
                            },
                            {
                                key: (0,utils.t)("pages.business.viral.sections.works.sections.sns.title2"),
                                title: (0,utils.t)("pages.business.viral.sections.works.sections.sns.title2"),
                                body: [
                                    (0,utils.t)("pages.business.viral.sections.works.sections.sns.body2-1"),
                                    (0,utils.t)("pages.business.viral.sections.works.sections.sns.body2-2"),
                                    (0,utils.t)("pages.business.viral.sections.works.sections.sns.body2-3"),
                                    (0,utils.t)("pages.business.viral.sections.works.sections.sns.body2-4"),
                                    (0,utils.t)("pages.business.viral.sections.works.sections.sns.body2-5"), 
                                ]
                            },
                            {
                                key: (0,utils.t)("pages.business.viral.sections.works.sections.sns.title3"),
                                title: (0,utils.t)("pages.business.viral.sections.works.sections.sns.title3"),
                                body: [
                                    (0,utils.t)("pages.business.viral.sections.works.sections.sns.body3-1"),
                                    (0,utils.t)("pages.business.viral.sections.works.sections.sns.body3-2"), 
                                ]
                            }, 
                        ],
                        imgSrc: "/pages/business/viral/sections/works/bg_insta.png",
                        imgProps: {
                            right: {
                                'md': "60vw",
                                'xl': "59vw",
                                '2xl': "57vw",
                                '3xl': "55vw"
                            },
                            maxW: "30rem",
                            pos: {
                                base: "relative",
                                md: "absolute"
                            },
                            top: {
                                md: "23%"
                            },
                            zIndex: 2
                        },
                        reverse: false
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(works_section_layout, {
                    title: "카페&커뮤니티 입소문 마케팅",
                    titleProps: {
                        textAlign: {
                            md: "left"
                        }
                    },
                    sectionProps: {
                        name: "worksViral",
                        sectionSize: layout/* SectionSize.LG */.f3.LG,
                        pbMult: 0.75
                    },
                    cardProps: {
                        variant: variant,
                        contentWrapProps: {
                            gap: "2rem",
                            pos: "relative",
                            left: {
                                md: "-3.8rem"
                            },
                            borderTopRadius: {
                                base: "2xl",
                                md: undefined
                            }
                        },
                        contents: [
                            {
                                key: (0,utils.t)("pages.business.viral.sections.works.sections.viral.title1"),
                                title: (0,utils.t)("pages.business.viral.sections.works.sections.viral.title1"),
                                body: [
                                    (0,utils.t)("pages.business.viral.sections.works.sections.viral.body1-1"),
                                    (0,utils.t)("pages.business.viral.sections.works.sections.viral.body1-2"), 
                                ]
                            },
                            {
                                key: (0,utils.t)("pages.business.viral.sections.works.sections.viral.title2"),
                                title: (0,utils.t)("pages.business.viral.sections.works.sections.viral.title2"),
                                body: [
                                    (0,utils.t)("pages.business.viral.sections.works.sections.viral.body2-1"),
                                    (0,utils.t)("pages.business.viral.sections.works.sections.viral.body2-2"),
                                    (0,utils.t)("pages.business.viral.sections.works.sections.viral.body2-3"),
                                    (0,utils.t)("pages.business.viral.sections.works.sections.viral.body2-4"), 
                                ]
                            },
                            {
                                key: (0,utils.t)("pages.business.viral.sections.works.sections.viral.title3"),
                                title: (0,utils.t)("pages.business.viral.sections.works.sections.viral.title3"),
                                body: [
                                    (0,utils.t)("pages.business.viral.sections.works.sections.viral.body3-1"),
                                    (0,utils.t)("pages.business.viral.sections.works.sections.viral.body3-2"), 
                                ]
                            },
                            {
                                key: (0,utils.t)("pages.business.viral.sections.works.sections.viral.title4"),
                                title: (0,utils.t)("pages.business.viral.sections.works.sections.viral.title4"),
                                body: [
                                    (0,utils.t)("pages.business.viral.sections.works.sections.viral.body4-1"),
                                    (0,utils.t)("pages.business.viral.sections.works.sections.viral.body4-2"), 
                                ]
                            }, 
                        ],
                        imgSrc: "/pages/business/viral/sections/works/bg_cafe.png",
                        imgProps: {
                            maxW: {
                                base: "40rem",
                                md: "50rem"
                            },
                            pos: {
                                base: "relative",
                                md: "absolute"
                            },
                            left: {
                                'md': "40vw",
                                '2xl': "50vw"
                            },
                            bottom: "10%",
                            zIndex: 2
                        },
                        reverse: true
                    }
                })
            ]
        });
    }, [
        variant
    ]);
    return contentNode;
};
/* harmony default export */ var works = (WorksSection);

// EXTERNAL MODULE: ./configs/motion-presets.ts + 1 modules
var motion_presets = __webpack_require__(4324);
// EXTERNAL MODULE: ./src/components/chakra-ui/index.ts + 3 modules
var chakra_ui = __webpack_require__(8182);
// EXTERNAL MODULE: ./src/components/chakra-ui/framer-motion/index.ts + 2 modules
var framer_motion = __webpack_require__(7994);
;// CONCATENATED MODULE: ./src/views/business/viral/sections/works/works-section-layout.tsx






function works_section_layout_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function works_section_layout_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            works_section_layout_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var WorksSectionLayout = function(param) {
    var // OPTIONAL
    title = param.title, titleProps = param.titleProps, cardProps = param.cardProps, sectionProps = param.sectionProps;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(layout/* GeneralSection */.d, works_section_layout_objectSpread({
        sectionProps: {
            overflow: "visible"
        }
    }, sectionProps, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion/* MotionHeading */.xn, works_section_layout_objectSpread({
                as: "h2",
                p: "0 1.8rem",
                textStyle: "heading-sm"
            }, motion_presets/* motionFadeUpProps */.E, titleProps, {
                children: title
            }), "works-section-title-".concat(title)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui/* Card */.Z, works_section_layout_objectSpread({}, cardProps))
        ]
    }));
};
/* harmony default export */ var works_section_layout = (WorksSectionLayout);

;// CONCATENATED MODULE: ./src/views/business/viral/sections/works/index.ts



;// CONCATENATED MODULE: ./src/views/business/viral/sections/index.ts





;// CONCATENATED MODULE: ./src/pages/business/viral.tsx




var ViralPage = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* BusinessPageLayout */.vr, {
        curPageIdx: 0,
        nextPageHref: "/business/media",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(about, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(specialty, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(process, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(works, {})
        ]
    }));
};
/* harmony default export */ var viral = (ViralPage);


/***/ }),

/***/ 7812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z3": function() { return /* reexport */ business_ProcessFeature; },
  "Eu": function() { return /* reexport */ specialty_feature; }
});

// UNUSED EXPORTS: SimpleCard

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+layout@1.7.7_@chakra-ui+system@1.11.2_react@17.0.2/node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(9034);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+image@1.1.8_@chakra-ui+system@1.11.2_react@17.0.2/node_modules/@chakra-ui/image/dist/chakra-ui-image.esm.js
var chakra_ui_image_esm = __webpack_require__(7080);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(9496);
;// CONCATENATED MODULE: ./src/views/business/ProcessFeature.tsx



var ProcessFeature = function(param) {
    var index = param.index, title = param.title, iconUrl = param.iconUrl, contents = param.contents, // OPTIONAL
    description = param.description;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
        mx: "auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                color: "white",
                fontSize: "1.3rem",
                fontWeight: "700",
                lineHeight: "1",
                mx: "auto",
                textAlign: "center",
                children: [
                    "STEP",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        fontSize: "2.8rem",
                        lineHeight: "1.2",
                        mb: "0.5rem",
                        children: index
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Circle */.Cd, {
                size: {
                    base: "9rem",
                    md: "12rem"
                },
                mx: "auto",
                mb: 6,
                bg: "white",
                color: "white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                    flexDir: "column",
                    justify: "center",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_image_esm/* Image */.Ee, {
                            src: iconUrl,
                            alt: title,
                            w: "90%",
                            mb: "0.2rem"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                            color: "brand.900",
                            fontSize: "1.3rem",
                            fontWeight: "800",
                            mx: "auto",
                            textAlign: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: title
                            })
                        })
                    ]
                })
            }),
            description ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                textAlign: "center",
                mx: "auto",
                bg: "brand.900",
                p: "0.5rem",
                color: "white",
                pos: "relative",
                borderRadius: "3xl",
                top: {
                    base: "-2.75rem",
                    md: "-3rem"
                },
                fontSize: "1.2rem",
                w: {
                    base: "63%",
                    md: "50%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                    mt: "0.25rem",
                    children: description
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                textAlign: "center",
                mx: "auto",
                p: "0.75rem",
                color: "white",
                pos: "relative",
                top: {
                    base: "-2.75rem",
                    md: "-3rem"
                },
                fontSize: "1.2rem",
                w: {
                    base: "63%",
                    md: "50%"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                textAlign: "center",
                mx: "auto",
                mt: "1rem",
                p: "0.5rem",
                color: "gray.300",
                pos: "relative",
                borderRadius: "20px",
                top: "-3rem",
                fontSize: {
                    base: "0.9rem",
                    md: "1.1rem"
                },
                w: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* List */.aV, {
                    spacing: 2,
                    children: contents.map(function(content) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* ListItem */.HC, {
                            children: content
                        }, content);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var business_ProcessFeature = (ProcessFeature);

;// CONCATENATED MODULE: ./src/views/business/SimpleCard.tsx


var SimpleCard = function(param) {
    var title = param.title, description = param.description, imgUrl = param.imgUrl;
    return(/*#__PURE__*/ _jsx(Flex, {
        borderRadius: "20px",
        p: 50,
        w: "full",
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/ _jsxs(Box, {
            bg: useColorModeValue("white", "gray.800"),
            maxW: "sm",
            // borderWidth="1px"
            borderRadius: "20px",
            rounded: "lg",
            shadow: "lg",
            position: "relative",
            children: [
                /*#__PURE__*/ _jsx(Image, {
                    src: imgUrl,
                    alt: "Picture of ".concat(title),
                    roundedTop: "lg",
                    roundedBottom: "lg"
                }),
                /*#__PURE__*/ _jsxs(Box, {
                    p: "6",
                    children: [
                        /*#__PURE__*/ _jsx(Box, {
                            d: "flex",
                            alignItems: "baseline"
                        }),
                        /*#__PURE__*/ _jsxs(Flex, {
                            mt: "1",
                            flexDir: "column",
                            justifyContent: "space-between",
                            alignContent: "center",
                            children: [
                                /*#__PURE__*/ _jsx(Box, {
                                    mb: "3",
                                    fontSize: "2xl",
                                    fontWeight: "semibold",
                                    as: "h4",
                                    lineHeight: "tight",
                                    isTruncated: true,
                                    children: title
                                }),
                                /*#__PURE__*/ _jsx(Box, {
                                    fontSize: "md",
                                    fontWeight: "normal",
                                    as: "p",
                                    lineHeight: "tight",
                                    children: description
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var business_SimpleCard = ((/* unused pure expression or super */ null && (SimpleCard)));

;// CONCATENATED MODULE: ./src/views/business/specialty-feature.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var CSS = {
    BORDER_COLOR: "192",
    BORDER_ALPHA: "0.5"
};
var SpecialtyFeature = function(param) {
    var title = param.title, description = param.description, iconUrl = param.iconUrl, // OPTIONAL
    wrapProps = param.wrapProps, iconProps = param.iconProps, iconWrapProps = param.iconWrapProps, textWrapProps = param.textWrapProps;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, _objectSpread({
        gap: {
            base: "5rem",
            md: "0"
        },
        mx: {
            md: "auto"
        },
        maxW: {
            md: "560px"
        }
    }, wrapProps, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Center */.M5, _objectSpread({
                mb: "2rem"
            }, iconWrapProps, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_image_esm/* Image */.Ee, _objectSpread({
                    src: iconUrl,
                    alt: title,
                    bg: "white",
                    p: "10px",
                    maxW: "70vw",
                    border: "1px solid rgba(".concat(CSS.BORDER_COLOR, ", ").concat(CSS.BORDER_COLOR, ", ").concat(CSS.BORDER_COLOR, ", ").concat(CSS.BORDER_ALPHA, ")"),
                    borderRadius: "50%",
                    boxShadow: "lg"
                }, iconProps))
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Center */.M5, _objectSpread({
                mx: "auto",
                color: "gray.600",
                textAlign: "center",
                w: {
                    base: "80%",
                    md: "85%"
                }
            }, textWrapProps, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                    children: description
                })
            }))
        ]
    }));
};
/* harmony default export */ var specialty_feature = (SpecialtyFeature);

;// CONCATENATED MODULE: ./src/views/business/index.ts





/***/ })

}]);